module.exports = __webpack_public_path__ + "upload.ad7c072eecc698b2ed4292ab7f31a854.svg";